import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import HeroWithCenteredImage from "../components/home-page/HeroWithCenteredImage";
import Footer from "../components/home-page/footer";
import EntranceAnimationInView from "../animations/EntranceAnimationInView";
import GridFeatures from "../components/home-page/GridFeatures";
import FeatureListSection from "../components/home-page/FeatureListSection";
import Header from "../components/navbars/HomeHeader";
import VerticalFlowDiagram from "../components/workflow/VerticalFlowDiagram";
import HowItWorksSection from "../components/home-page/HowItWorksSection";
import FAQ from "../components/home-page/FAQ";
import AIEmailSection from "../components/home-page/AIEmailSection";
import CampaignOptimizationSection from "../components/home-page/CampaignOptimizationSection";
import { CallToAction } from "../components/CallToAction";
import LogoCloud from "../components/home-page/LogoCloud";

function HomePage() {
  usePageTitle("AI-Powered Customer Engagement on Autopilot");
  return (
    <>
      <Header overlay />
      <HeroWithCenteredImage />
      <EntranceAnimationInView>
        <LogoCloud />
      </EntranceAnimationInView>
      <VerticalFlowDiagram />
      <EntranceAnimationInView>
        <HowItWorksSection />
      </EntranceAnimationInView>
      <EntranceAnimationInView>
        <AIEmailSection />
      </EntranceAnimationInView>
      <EntranceAnimationInView>
        <CampaignOptimizationSection />
      </EntranceAnimationInView>
      {/* <EntranceAnimationInView>
        <FeatureListSection />
      </EntranceAnimationInView> */}
      {/* <EntranceAnimationInView>
        <GridFeatures />
      </EntranceAnimationInView> */}
      <EntranceAnimationInView>
        <FAQ />
      </EntranceAnimationInView>
      <EntranceAnimationInView>
        <CallToAction />
      </EntranceAnimationInView>
      <Footer />
    </>
  );
}

export default HomePage;
